import axios, { getData } from 'lib/axios'

//fetching parameters of specific single form
export const getAppraisal = (appraisalId) => {
  return axios.get(`/admin/appraisals/${appraisalId}`).then(getData)
}
export const getAppraisalEvals = (appraisalId) => {
  return axios.get(`admin/appraisals/${appraisalId}/evaluations`).then(getData)
}

export const getAllAppraisal = () => {
  return axios.get('/admin/appraisals').then(getData)
}

export const createAppraisal = (data) => {
  return axios.post('/admin/appraisals', data).then(getData)
}

export const saveAppraisal = (appraisalId, data) => {
  return axios.put(`/admin/appraisals/${appraisalId}`, data).then(getData)
}

export const deleteAppraisal = (appraisalId) => {
  return axios.delete(`/admin/appraisals/${appraisalId}`).then(getData)
}

export const cancelAppraisal = (appraisalId) => {
  return axios.post(`admin/appraisals/cancel/${appraisalId}`).then(getData)
}

export const uploadMatching = async ({ evalId, data }) => {
  return await axios.post(`/admin/evaluations/${evalId}/participants/upload`, data).then(getData)
}

export const confirmUploadMatching = async ({ evalId, data }) => {
  return await axios.post(`admin/evaluations/${evalId}/participants/bulk`, data).then(getData)
}

export const addCustomMatchingEval = async (data) => {
  return await axios.post(`admin/evaluations/add`, data).then(getData)
}

export const addNoNCustomMatchingEval = async ({ appraisalId, data }) => {
  return await axios.post(`admin/evaluations/add/bulk/${appraisalId}`, data).then(getData)
}

export const addBulkNonCustomMatchingEval = async ({ appraisalId, data }) => {
  return await axios.post(`admin/evaluations/add/bulk/${appraisalId}`, data).then(getData)
}

export const addExternalEval = async (data) => {
  return await axios.post(`admin/evaluations/external`, data).then(getData)
}

export const addExternalEvalUpload = async ({ data }) => {
  return await axios.post(`admin/evaluations/upload`, data).then(getData)
}

export const confirmExternalEvalUpload = async ({ data, evalId }) => {
  return await axios.post(`admin/evaluations/${evalId}/bulk`, data).then(getData)
}
